<template>
  <div class="vue-template vue-template-flex">
    <h1 class="display-1 text-center">Erro 404!</h1>
    <p class="text-center lead">page not found.</p>
  </div>
</template>

<script>
export default {
  name: "404",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "User doesn't on NowNow.one",
    // all titles will be injected into this template
    titleTemplate: null,
  },
};
</script>

<style>
</style>